import dayjs from 'dayjs';

/* Format eg. 28/01/2023 */
export const formatDate = (date) => {
  if(!date) return '--/--/----';
  return dayjs(date).format('DD/MM/YYYY')
}

/* Format eg. 28/01/2023 11:30 PM */
export const formatDateTime = (date) => {
  if(!date) return '--/--/---- --:-- --';
  return dayjs(date).format('DD/MM/YYYY hh:mm A')
}